import { MiniHealthCheck } from "shared/request/myHealthyAdvantageApi";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import { StructuredText, StructuredTextDocument } from "react-datocms";
import Button from "shared/UI/Buttons/Button";
import { useTranslation } from "react-i18next";
import { NarrowContainer } from "shared/UI/LayoutComponents/LayoutComponents";

export type MiniHealthCheckIntroProps = {
  miniHealthCheck: MiniHealthCheck;
  onStartTest: VoidFunction;
};

export const MiniHealthCheckIntro = ({ miniHealthCheck, onStartTest: handleStartTest }: MiniHealthCheckIntroProps) => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader narrowView title={t("completeMiniHealthCheck.title", { name: miniHealthCheck.name })} />
      <NarrowContainer>
        <div className="col-span-2">
          <StructuredText data={miniHealthCheck.intro as StructuredTextDocument} />

          <div className="flex flex-row justify-evenly w-full pt-10">
            <div className="w-full md:w-80">
              <Button text={t("completeMiniHealthCheck.startTest")} onClick={handleStartTest} />
            </div>
          </div>
        </div>
      </NarrowContainer>
    </>
  );
};
